module.exports = __webpack_public_path__ + "img/reward_2400.09de928f.png";